import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, errorTranslate } from "../util";

export const addProductImages = ({
  image,
  callback = null,
  publicId,
  productId,
}) => {
  const config = {
    method: "post",
    url: baseUrl + "/api/business/product/" + productId + "/add-product-image",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      image: image,
      public_id: publicId,
    },
  };

  return axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        confirmButtonColor: "#a9c1b4",
        color: "#476355",
        background: "#f1f8ef",
      });
      if (callback) callback();
      return response;
    })
    .catch(function (error) {
      console.error("Error adding product image:", error);
      throw error;
    });
};

export const updateProductImages = ({
  image,
  publicId,
  swal = false,
  productId,
  objectId,
}) => {
  const data = {
    image: image,
    public_id: publicId,
  };

  const config = {
    method: "put",
    url: `${baseUrl}/api/business/product/${productId}/${objectId}/update-product-image`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      if (swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      return response;
    })
    .catch(function (error) {
      if (swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      throw error;
    });
};

export const getProductImages = ({ productId }) => {
  const config = {
    method: "get",
    url: `${baseUrl}/api/business/product/${productId}/get-product-image`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  return axios(config)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      if (error.response?.status === 404) {
        console.log("No images found for this product.");
        return { data: { images: [] } };
      }
      throw error;
    });
};

export const deleteProductImages = ({
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  productId,
  objectId,
}) => {
  const config = {
    method: "delete",
    url: `${baseUrl}/api/business/product/${productId}/${objectId}/delete-product-image`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  if (loading) setLoading("load");

  return axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      return response;
    })
    .catch(function (error) {
      console.error("Error deleting product image:", error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      throw error;
    });
};
